import { t } from "../i18n";
export function downloadJson(filename: string, data: unknown): void {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.rel = "noopener";
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
export function readJsonFile(file: File): Promise<unknown> {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onerror = () => reject(new Error("Dosya okunamadı"));
    r.onload = () => { try { resolve(JSON.parse(String(r.result))); } catch { reject(new Error("Dosya geçerli JSON değil")); } };
    r.readAsText(file, "utf-8");
  });
}

/** Metin dosyası indir (CSV, DXF …). */
export function downloadText(filename: string, text: string, mime = "text/plain;charset=utf-8"): void {
  downloadBlob(filename, new Blob([text], { type: mime }));
}
/** İkili dosya indir (kod sayfalı DXF vb.). */
export function downloadBytes(filename: string, bytes: Uint8Array<ArrayBuffer>, mime = "application/octet-stream"): void {
  downloadBlob(filename, new Blob([bytes], { type: mime }));
}
import { requireFullAccess } from "../billing/access";

/** Dosya çıktısı (DXF/Word/XLSX/CSV/PDF); ücretsiz katmanda ödeme duvarı açılır. Proje JSON'u serbest (downloadJson). */
export function downloadBlob(filename: string, blob: Blob): void {
  if (!requireFullAccess(t("Dosya çıktıları (PDF, Word, DXF, XLSX, CSV)"))) return;
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.rel = "noopener";
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
